import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { setPromoCodeInputDisplay } from '../../redux/actions/setSystemSettings';

/**
 * Loads SPA system settings (tsys_system) from the new Symfony B2C API once on app
 * startup and stores them in Redux. Renders nothing.
 *
 * Currently fetches the `spa_promo_code_input_display` toggle which controls whether
 * the promo code input is shown. On any failure the Redux default (visible) is kept,
 * so a network/auth error never hides an otherwise-working input.
 */
const SystemSettingsLoader = () => {
  const dispatch = useDispatch();
  const hasFetched = useRef(false);

  useEffect(() => {
    // Guard against React StrictMode's double effect invocation in development.
    if (hasFetched.current) {
      return;
    }
    hasFetched.current = true;

    const baseURL = process.env.REACT_APP_PLATFORM_APP_API_BASE_URL;
    const headers = {
      'Content-Type': 'application/json'
    };

    fetch(`${baseURL}/b2c/api/parameters/promo-code-visibility`, {
      method: 'GET',
      headers,
    })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (data && typeof data.promoCodeInputDisplay === 'boolean') {
          dispatch(setPromoCodeInputDisplay(data.promoCodeInputDisplay));
        }
      })
      .catch(() => {
        // Keep the default (input visible) when the settings request fails.
      });
  }, [dispatch]);

  return null;
};

export default SystemSettingsLoader;
